import clsx from 'clsx'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getNewEstimateValue, getUser } from '../../../../../../ducks/selectors'
import { USER_TYPE, history, roleOptions } from '../../../../../../helpers'
import { useStepperContext } from '../../../../../../hooks/useStepperContext'
import { Avatar, BottomLink, Box, Grid, LinearProgress, Radio, TextFieldLabel, Typography } from '../../../../../UI'
import useStyles from './styles'


const Role = () => {
  const classes = useStyles()

  const user = useSelector(getUser)
  const push = history.usePush()
  const { saveNewValue, setShowWarnings, showWarnings, setCanGoForward } = useStepperContext()
  const mainContact = useSelector(getNewEstimateValue('mainContact'))

  const [workType, setworkType] = useState(user.clientType || mainContact?.clientType)
  const [firstName, setFirstName] = useState(user.firstName || mainContact?.firstName)
  const [lastName, setLastName] = useState(user.lastName || mainContact?.lastName)

  const handleSelect = (idx: any): void => {
    setworkType(idx)
    saveNewValue('clientType', idx)
    setShowWarnings(false)

    if (idx !== USER_TYPE.BROKER) {
      saveNewValue('nar', false)
    }
  }

  useEffect(() => {
    if (user?.nar || !isEmpty(user?.affiliate)) {
      setworkType(USER_TYPE.BROKER)
    }
  }, [user?.nar])

  useEffect(() => {
    if (!isEmpty(workType) && !isEmpty(firstName) && !isEmpty(lastName)) {
      setCanGoForward(true)
    }
  }, [workType, firstName, lastName])

  return (
    <>
      <Grid item>
        <Typography variant="h5" className={classes.title}>tell us more about you</Typography>
      </Grid>
      <Grid>
        <LinearProgress variant="determinate" value={!isEmpty(workType) && !isEmpty(firstName) && !isEmpty(lastName) ? 30 : 0} />
        <Grid container spacing={3}>
          <Grid xs={12} md={6} item>
            <TextFieldLabel
              label="First Name:"
              error={showWarnings && isEmpty(firstName?.trim())}
              onChange={(ev) => {
                setFirstName(ev.target.value)
                saveNewValue('firstName', ev.target.value)
              }}
              value={firstName}
              placeholder="Enter your name"
            />
          </Grid>
          <Grid xs={12} md={6} item>
            <TextFieldLabel
              label="Last Name:"
              error={showWarnings && isEmpty(lastName?.trim())}
              onChange={(ev) => {
                setLastName(ev.target.value)
                saveNewValue('lastName', ev.target.value)
              }}
              value={lastName}
              placeholder="Enter your last name"
            />
          </Grid>
        </Grid>
        <Typography className={classes.subtitle}>Your role</Typography>
      </Grid>
      <Grid spacing={2} className={classes.options}>
        {roleOptions.map((item, index) => (
          <Grid
            item
            xs={12}
            key={index}
            className={clsx(
              classes.option,
              workType === item.id && classes.selected
            )}
            onClick={() => handleSelect(item.id)}
          >
            <Box className={classes.content}>
              <Avatar
                alt=""
                src={item.icon}
                className={classes.iconJob}
                variant="square"
              />
              <Box className={classes.details}>
                <Typography variant="body1">
                  {item.title}
                </Typography>
              </Box>
            </Box>
            <Radio
              color="primary"
              disableRipple
              checked={workType === item.id}
              style={{ backgroundColor: 'transparent' }}
            // classes={{ checked: classes['Mui-checked'] }}
            />
          </Grid>
        ))}
        <BottomLink
          question='Already have an account?'
          linkText='Sign in here'
          onClick={() => {
            push('login')
          }}
        />
      </Grid>
    </>
  )
}

export default Role
